import axios from 'axios';
import api from "./cognito";
import store from '../store'

var base_url = "https://qc3izcaea8.execute-api.us-east-1.amazonaws.com/api/"

// Local Hosting - Uncomment the following line.
// base_url = "https://h1ar2zrzof.execute-api.us-east-1.amazonaws.com/api"

export default {
    async getProgramData(program, year) {
        // Route to get metric data from the backend for a given program and year
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").toLowerCase() + "_" + String(year)
                    let path = `/metricdata?id=${id}`;
                    let url = base_url + path
                    let request = {
                        method: 'GET',
                        url: url,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async getProgramDataForYear(year) {
        // Route to get metric data from the backend for a given program and year
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let path = `/programs?year=${year}`
                    let url = base_url + path
                    let request = {
                        method: 'GET',
                        url: url,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async getMetricData(program, year) {
        // Route to get metric data from the backend for a given program and year
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").toLowerCase() + "_" + String(year)
                    let path = `/metrics?id=${id}`
                    let url = base_url + path
                    let request = {
                        method: 'GET',
                        url: url,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async editDecimal(body, program, year) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").toLowerCase() + "_" + String(year);
                    let path = `/metrics/decimalAndCategory?id=${id}`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'PUT',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    // /metrics/target/{program_year_key}
    async editMetricTarget(body, program, year) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let program_year_key = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").split(" ").join("_").toLowerCase() + "_" + String(year);
                    let path = `/metrics/target/${program_year_key}`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'PUT',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async editMericsStatus(body, program, year) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").split(" ").join("_").toLowerCase() + "_" + String(year);
                    let path = `/metrics/status/${id}`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'PUT',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    // /program/status/{program_year_key}
    async editProgramStatus(body, program, year) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").split(" ").join("_").toLowerCase() + "_" + String(year);
                    let path = `/programs/status/${id}`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'PUT',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async editProgramName(body) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let path = `/programs/name`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'PUT',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async updateChangesToDB(program, year, type, body) {
        // post route to update the db
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(program).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").toLowerCase() + "_" + String(year)
                    let path = `/updateDB?id=${id}&type=${type}`;
                    let url = base_url + path
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'POST',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async getCommentaryData(mainCategory, subCategory, year, period) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    mainCategory = String(mainCategory).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").replace("__","_").toLowerCase();
                    subCategory = String(subCategory).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").replace("__","_").toLowerCase();
                    let path = `/commentarydata?maincategory=${mainCategory}&subcategory=${subCategory}&year=${year}&period=${period}`;
                    let url = base_url + path
                    let request = {
                        method: 'GET',
                        url: url,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async deleteComments(body, metaData) {
        var key = body[0].programName.trim().replace(/ - /, "_").replace(/-/, "").split(" ").join("_").toLowerCase() + '_' + body[0].year;
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let path = `/programcomments`;
                    const postCommentsUuid = body.map(i => {
                        return i.uuid
                    });
                    let postBody = {
                        [key]: postCommentsUuid
                    };
                    let url = base_url + path;
                    let data = JSON.stringify(postBody);
                    let request = {
                        method: 'DELETE',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async updateComments(body) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let path = `/programcomments`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'POST',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async editComments(body) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(async function(token){
                if(token){
                    let id = String(body.programName).trim().replace("-", "").replace("  ", " ").replace(".", "").replace("&", "").split(" ").join("_").toLowerCase() + "_" + String(body.year)
                    let path = `/programcomments/?id=${id}`;
                    let url = base_url + path;
                    let data = JSON.stringify(body)
                    let request = {
                        method: 'PUT',
                        url: url,
                        data: data,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    resolve(axios(request))
                } else {
                    store.dispatch('sessionTimedOut')
                }
            })
        })
    },
    async getMenuOptions(all = false) {
        return await new Promise((resolve, reject) => {
            api.get_id_token(function(token){
                if(token){
                    let path = "/menuOptions";
                    if (all) {
                        path += '?filter_inactive_programs=false'
                    }

                    let url = base_url + path;
                    let request = {
                        method: 'GET',
                        url: url,
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            'Content-Type': 'application/json; charset=UTF-8',
                            'Authorization': store.getters.currentIdToken
                        }
                    }
                    console.log(request)
                    let response = axios(request)
                    console.log(response)
                    resolve(response)
                }  else {
                    store.dispatch('sessionTimedOut')
                }
            })
        }) 
    }
}
